import React, { useEffect, useState } from "react";
import { Checkbox, Form } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

import useTranslation from "../../hooks/useTranslation";

import TEXT from "../../config/text";
import REQUESTS from "../../api/requests";

import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import style from "./style/style.module.scss";
import ErrorModal from "../../components/ErrorModal";

export default function AddPlaylistByUrl({
  deviceMac,
  getPlaylists,
  onCancel,
  form,
}) {
  const [loading, setLoading] = useState(false);
  // const [form] = Form.useForm();

  const [errorMessage, setErrorMessage] = useState(null);

  const [isProtected, setIsProtected] = useState(false);

  // const [playlistName, setPlaylistName] = useState("");

  const translation = useTranslation();

  const handleText = (text) => {
    if (translation?.pages?.playlist?.[text]) {
      return translation?.pages?.playlist?.[text];
    }

    return TEXT?.pages?.playlist?.[text];
  };

  const onFinish = (values) => {
    const { name, url, pin, confirm_pin,epg_url } = values;
    setLoading(true);
    setErrorMessage(null);

    const formData = new FormData();

    formData.append("name", name);
    formData.append("mac", deviceMac);
    formData.append("is_protected", isProtected);

     if (url) {
      formData.append("url", url.split(" ").join(""));
     }
    
    if (isProtected) {
      formData.append("pin", pin);
      formData.append("confirm_pin", confirm_pin);
    }

    if (epg_url) {
      formData.append("epg_url",epg_url.split(" ").join(""));
    }

    function callback() {
      setLoading(false);
      getPlaylists();
      onCancel();
      form.resetFields();
    }

    function errorCallback(error) {
      setErrorMessage(error.message);
      setLoading(false);
    }

    REQUESTS.UPLOAD_PLAYLIST(formData, callback, errorCallback);
  };

  useEffect(() => {
    form.resetFields();
    setIsProtected(false);
  }, []);

  return (
    <div>
      <Form
        form={form} onFinish={onFinish}
        className={style["add-modal-form"]}
      >
        <div style={{ width: "100%" }}>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: handleText("playlist_name_message"),
              },
            ]}
          >
            <InputComponent placeholder={handleText("playlist_name")} />
          </Form.Item>

          <Form.Item
            name="url"
            rules={[
              {
                required: true,
                message: handleText("playlist_url_message"),
                validator: (rule, value, callback) => {
                  if (value && !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(value)) {
                    callback('Please enter a valid URL');
                  } else {
                    callback();
                  }
                }
              },
            ]}
          >
            <InputComponent placeholder={handleText("playlist_url")} />
          </Form.Item>
          <Form.Item
            name="epg_url"
            rules={[
              {
                validator: (rule, value, callback) => {
                  if (value && !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(value)) {
                    callback('Please enter a valid URL');
                  } else {
                    callback();
                  }
                }
              },
            ]}
          >
            <InputComponent placeholder={handleText("playlist_epg_url")} />
          </Form.Item>

          <Checkbox
            checked={isProtected}
            onChange={(e) => setIsProtected(e.target.checked)}
            className={style["protected-playlist-checkbox"]}
          >
            {handleText("protect_playlist")}
          </Checkbox>
          <div>
            <Form.Item
              name="pin"
              rules={[
                {
                  required: isProtected ? true : false,
                  message: "Please input your password!",
                },
              ]}
              hasFeedback
            >
              <InputComponent
                type="password"
                placeholder={handleText("set_pin")}
                disabled={!isProtected}
              />
            </Form.Item>

            <Form.Item
              name="confirm_pin"
              dependencies={["pin"]}
              hasFeedback
              rules={[
                {
                  required: isProtected ? true : false,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("pin") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <InputComponent
                type="password"
                placeholder={handleText("confirm_pin")}
                disabled={!isProtected}
              />
            </Form.Item>
          </div>

          <div style={{ marginTop: "40px", textAlign: "center" }}>
            <ButtonComponent
              onClick={() => form.submit()}
              loading={loading}
              title={handleText("url_button_title")}
            />
          </div>
        </div>
      </Form>
      <ErrorModal
        message={errorMessage}
        visible={errorMessage ? true : false}
        onClose={() => setErrorMessage(null)}
      />
    </div>
  );
}
